
// Import React and Link from react-router-dom for navigation
import React from "react";
import { Link } from "react-router-dom";


// Breadcrumbs component displays a navigation trail based on the provided crumbs array
// Each crumb should be an object with 'name' and optional 'link' properties
const Breadcrumbs = ({crumbs}) => {
  return (
    // Container for styling and spacing
    <div className="tablet:padding-x-5 padding-y-3 margin-x-5">
      {/* Navigation element for accessibility */}
      <nav className="usa-breadcrumb--wrap" aria-label="Breadcrumbs">
        <ol className="usa-breadcrumb__list">
          {/* Map over crumbs to render each breadcrumb item */}
          {crumbs.map((crumb, index) => {
            return (
              <li key={index} className="usa-breadcrumb__list-item">
                {/* If crumb has a link, render as a clickable Link, otherwise plain text */}
                {crumb.link ? 
                  <Link to={crumb.link} className="usa-breadcrumb__link"><span>{crumb.name}</span></Link>
                  :
                  <span>{crumb.name}</span>
                }
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
}


// Export the Breadcrumbs component for use in other parts of the app
export default Breadcrumbs;
